import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import LandingPage from "@/pages/LandingPage";
import BookingPage from "@/pages/BookingPage";
import { businessConfig } from "@/config";
import { applyTheme } from "@/lib/theme";

function App() {
  // Apply the client palette once on mount — overrides the CSS defaults
  // with values from `businessConfig.colors` so a single config edit
  // rebrands the whole site.
  useEffect(() => {
    applyTheme(businessConfig.colors);
    // Theme is applied once on mount from a module-level constant.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/book" element={<BookingPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors closeButton />
    </div>
  );
}

export default App;
